import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { firstValueFrom, throwError } from 'rxjs';
import { AuthenticatedHttpClient } from 'src/app/auth/authenticatedHttpClient';
import { environment } from 'src/environments/environment';
import * as Sentry from '@sentry/angular';
import {
  LanguageQualification,
  Qualifications,
} from '../models/qualifications.model';
import { LoggerService } from 'src/app/services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class QualificationsService {
  constructor(private readonly http: AuthenticatedHttpClient) {}

  private apiUrl = `${environment.carmovaApiUrl}`;

  private logger = new LoggerService(QualificationsService.name);

  getQualifications(): Promise<Qualifications> {
    return firstValueFrom(
      this.http.get<Qualifications>(this.apiUrl + '/drivers/current-ppl').pipe(
        catchError((error) => {
          Sentry.captureException(error);
          return throwError(
            () => new Error('movacarpro_error_fetching_qualifications'),
          );
        }),
      ),
    );
  }

  getLanguageQualifications(): Promise<LanguageQualification[]> {
    return firstValueFrom(
      this.http
        .get<
          LanguageQualification[]
        >(this.apiUrl + '/drivers/language-qualifications')
        .pipe(
          catchError((error) => {
            Sentry.captureException(error);
            return throwError(
              () =>
                new Error('movacarpro_error_fetching_language_qualifications'),
            );
          }),
        ),
    );
  }

  async updateDriverPremiumPartnerLevel(): Promise<number> {
    try {
      const updatedPremiumPartnerLevel = await firstValueFrom(
        this.http
          .patch<number>(this.apiUrl + '/drivers/premium-partner-level', null)
          .pipe(
            catchError((error) => {
              Sentry.captureException(error);

              return throwError(
                () => new Error('movacarpro_error_updating_driver_ppl'),
              );
            }),
          ),
      );

      return updatedPremiumPartnerLevel;
    } catch (error) {
      this.logger.error({
        message: `${error instanceof Error ? error.message : String(error)}`,
        identifier: 'movacarpro_error_updating_driver_ppl',
        method: 'updateDriverPremiumPartnerLevel',
      });

      throw error;
    }
  }
}
